import { useQuery } from '@apollo/client';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import type { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { BackHeader } from '../../../components/common/backheader/BackHeader.component';
import { MarketplaceComponent } from '../../../components/marketplace/Marketplace.component';
import { useWeb3State } from '../../../hooks';
import { WEB3_CONFIG } from '../../../lib';
import type { AccountAsset } from '../../../lib/graph/MogulMarketplace';
import accountAssetByAccountQuery from '../../../lib/graph/queries/accountAssetByAccountQuery';

export const OwnedNftMarketplacePage: FC = () => {
  const history = useHistory();
  const params = new URLSearchParams(useLocation().search);
  const { walletDetails } = useWeb3State();
  const walletAddress = walletDetails.address?.toLowerCase();
  const MARKETPLACE_NETWORK =
    WEB3_CONFIG.contracts[walletDetails.chain.key].mogulMarketplaceErc1155;

  const renderSidebar = params.get('from') === 'sidebar';

  const marketplaceAddress = MARKETPLACE_NETWORK.toLowerCase();

  const addresses = [walletAddress, marketplaceAddress];
  const { data, loading } = useQuery<{
    accountAssets: AccountAsset[];
  }>(accountAssetByAccountQuery, { variables: { addresses } });

  const assets = data?.accountAssets
    .filter(
      accountAsset =>
        accountAsset.account.address === walletAddress ||
        accountAsset.asset.activeListings?.filter(
          l => l.seller.address === walletAddress,
        ).length,
    )
    .map(accountAsset => accountAsset.asset)
    .filter((v, i, a) => a.findIndex(t => t.id === v.id) === i);

  const goToMarketplace = () => {
    history.push('/platform/marketplace');
  };

  const returnToDashboard = () => {
    history.push('/platform/dashboard');
  };

  return (
    <div className="flex flex-col h-auto bg-container bg-repeat bg-cover min-h-full">
      <Box className="lg:pl-14 pt-5">
        {!renderSidebar ? (
          <BackHeader
            title="back to marketplace"
            headerOnPress={goToMarketplace}
          />
        ) : (
          <BackHeader
            title="return to dashboard"
            headerOnPress={returnToDashboard}
          />
        )}
      </Box>
      <div className="flex flex-col items-center">
        <div className="max-w-screen-lg lg:w-full mb-20">
          <div className="fontVanguard font-bold xl:text-7xl md:text-6xl text-4xl mt-8 mb-12 ml-4">
            Your Digital Collectibles
          </div>
          {!loading ? (
            assets?.length != null && assets.length > 0 ? (
              <div className="mt-8 ml-4">
                <MarketplaceComponent assets={assets} yourNfts={true} />
              </div>
            ) : (
              <div className="fontVanguard xl:text-4xl md:text-6xl text-4xl mt-8 mb-20 ml-4 h-full">
                You Don't Own Any Items
              </div>
            )
          ) : (
            Array(4)
              .fill(0)
              .map((_, i) => (
                <Skeleton
                  key={i}
                  animation="wave"
                  variant="rect"
                  width={280}
                  height={100}
                />
              ))
          )}
        </div>
      </div>
    </div>
  );
};
